import { Request } from '@/http/request'

// 通信接口增添
export function industryQuery(parameter: any){
  return Request.axiosInstance.post('/open/industry/query', parameter)
}